import { AbstractCommand } from 'src/models/command';
import { IdoFavorite } from 'src/models/organization';

class UpdateIdoFavoriteOrderCommand extends AbstractCommand {
	readonly name = 'IFS_Organization_IdoLinkDropZone_Command_Command_UpdateIdoFavoriteOrder';

	public constructor(idoFavorites: Array<IdoFavorite>) {
		super();
		this.parameters = {
			idoFavorites: idoFavorites,
		};
	}
}

export { UpdateIdoFavoriteOrderCommand };
